import { combineReducers } from "redux"
import { reducer as form } from "redux-form"

import { customer, modal, customerOpenInvoices } from "./customer/reducer"
// import { bills, invoices, products, febraban } from './billing/reducer'
import { negotiation } from "./negotiation/reducer"
import {
  bills,
  invoices,
  products,
  febraban,
  monthsDetailing,
  debit,
  updateProducts,
  traffic,
  trafficDetails,
  trafficMail,
  downloadTraffic,
  billSetAlias
} from "./billing/reducer"
import { auth } from "./auth/reducer"
import { permissions } from "./permissions/reducer"
import { system } from "./system/reducer"
import { repair } from "./repair/reducer"
import { rescheduling } from "./rescheduling/reducer"
import { recharge } from "./recharge/reducer"
import { technician } from "./technician/reducer"
import { freecalls } from "./freecalls/reducer"
import { documents } from "./documents/reducer"
import { quotation } from "./quotation/reducer"
import { usage } from "./usage/reducer"
import {
  portabilityInformation,
  newOrder,
  customersFixedVoice,
  actionsDashFixedVoice
} from "./fixedVoice/reducer"
import oAuthSensedia from "./sensedia/reducer"
import sensediaCorpAuth from "./sensediaCorp/reducer"
import { svas, interfaceOnline } from "./interface/reducer"
import { invoiceDisputing } from "./invoiceDisputing/reducer"
import { myCalls } from "./myCalls/reducer"
import { nbo } from "./nbo/reducer"
import { productsSharedData } from "./sharedData/reducer"

const appReducer = combineReducers({
  customer,
  modal,
  bills,
  invoices,
  products,
  febraban,
  auth,
  permissions,
  form,
  negotiation,
  monthsDetailing,
  debit,
  system,
  traffic,
  updateProducts,
  trafficDetails,
  trafficMail,
  downloadTraffic,
  repair,
  rescheduling,
  recharge,
  technician,
  freecalls,
  quotation,
  documents,
  usage,
  oAuthSensedia,
  sensediaCorpAuth,
  billSetAlias,
  svas,
  interfaceOnline,
  customerOpenInvoices,
  portabilityInformation,
  newOrder,
  customersFixedVoice,
  actionsDashFixedVoice,
  invoiceDisputing,
  myCalls,
  nbo,
  productsSharedData
})

const APP_INITIAL_STATE = appReducer({}, {})

const rootReducer = (state, action) => {
  if (action.type === "LOGOUT") {
    state = APP_INITIAL_STATE
  }

  return appReducer(state, action)
}

export default rootReducer



// WEBPACK FOOTER //
// ./src/services/state/reducers.js